import { AngularFirestore } from '@angular/fire/firestore';
import { Injectable } from '@angular/core';
import { ProductSelectorService } from './product-selector.service';
import { Query } from '@firebase/firestore-types';
import { switchMap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProductListService {

  constructor(
    private database: AngularFirestore,
    private productSelector: ProductSelectorService
  ) {}

  get products() {
    return this.productSelector.selectedProduct.pipe(switchMap(product => {
        return this.database.collection('products', ref => {
          let query: Query = ref;
          if (product) {
            query = query.where('categoryChild', '==', product.categoryChild);
          }
          return query;
        }).valueChanges();
      })
    );
  }
}
